import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getArticles(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/articles/list", requestData, this.requestConfig());
  }

  static addArticle(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/articles/create", requestData, this.requestConfig());
  }

  static updateArticle(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/articles/update", requestData, this.requestConfig());
  }

  static getCategories() {
    return axios.get(ENV.dealerBaseUrl + "/articles/categories/list", this.requestConfig());
  }
}

export default Service;
